// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-title[data-v-691eecc0]{color:var(--v-gray-ultra-dark);font-size:24px;letter-spacing:.2px;margin-left:var(--spacer)}", ""]);
// Exports
module.exports = exports;
